import { styled } from "styled-components";
import { useSearchspringPLPContext } from "../../contexts/SearchspringPLPContext";
import { colors } from "../../lib/sharedStyles";
import PLPGridIcon from "../Icons/PLPGridIcon";
import PLPListIcon from "../Icons/PLPListIcon";

export type PLPViewOption = 'grid' | 'list';
const PLPViewOptions: { value: PLPViewOption, Icon: any }[] = [
  { value: 'grid', Icon: PLPGridIcon },
  { value: 'list', Icon: PLPListIcon },
];

const StyledButton = styled.button`
  padding: 0;
  margin: 0 0 0 8px;

  svg {
    vertical-align: bottom;
  }
`;

const PLPViewSelector = () => {
  const { viewOption, toggleViewOption } = useSearchspringPLPContext();

  return PLPViewOptions.map(({ value, Icon }) => {
    const color = (value == viewOption) 
      ? colors.fender.primaryDark
      : colors.fender.grey03;

    return (
      <StyledButton 
        key={value} 
        onClick={() => toggleViewOption(value)}
      >
        <Icon color={color} />
      </StyledButton>
    );
  });
}

export default PLPViewSelector;